import { gte, pathOr } from 'ramda';
import { getGraphQLAuthToken, getGraphQLPublicAuthToken } from 'src/services/graphql/auth';
import { isNotEmpty, returnIsNotEmptyOrTrue } from 'src/utilities/hasValue';
import { authenticatedUser } from 'src/utilities/storage';



class CoreAPIKeyFacade {
    hasuraToken: string;
    name: string = 'coreapi';
    // Seconds 
    expiresIn: number;
    expiresAt: any;




    /**
     * getToken returns a JWT token.
     *
     * Verify if there is a Hasura Token and if it expired.
     * If its expired then regenereate one
     *
     * Reference: jwt.io
     */
    async getToken() {
        //#1: Use case - When there is hasura token then decode that
        // and verify if it expired.
        // If expired then generate a new token.
        const now = Math.floor(Date.now() / 1000);
        const expiresAt = returnIsNotEmptyOrTrue(this.expiresAt, this.expiresAt, 0)
        const requestNewToken = gte(now, Number(expiresAt) - 5)
        if (requestNewToken) {
            await this.sign();
        }
        return this.hasuraToken;
    }

    private async sign() {
        const fn = isNotEmpty(authenticatedUser.accountId.get()) ? getGraphQLAuthToken :  getGraphQLPublicAuthToken;
        return fn().then((response: any) => {
            this.hasuraToken = pathOr('', ['access_token'], response)
            this.expiresIn = authenticatedUser.accountId.get()  ? Number(pathOr(0, ['expires_in'], response)) : 0
            this.expiresAt = Math.floor(Date.now() / 1000) + this.expiresIn
        })
    }
}



export default CoreAPIKeyFacade;

